import React, { useEffect, useState } from 'react';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import { getRemotedbUrl } from '../../lib/ep';
import FloatingLayer from '../builder/FloatingLayer';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle';

const useChargeBeeInstance = () => {
	const [ cbInstance, setCBinstance ] = useState(false);
	
	useEffect(() => {
		setTimeout(() => {
			setCBinstance(window.Chargebee.getInstance())
		}, 200);
	}, []);
	return cbInstance;
}

export const priceAddon = (type,plan,currency) => {
		
	const pay_mode_string = (plan.pay_mode == 0) ? 'Monthly' : 'Yearly';
	
	const _prizes = {
		'ADDITIONAL-DOMAIN': { 
		  5: {Monthly: { USD: 20, EUR: 20,}, Yearly: { USD: 240, EUR: 240,}},
		  6: {Monthly: { USD: 20, EUR: 20,}, Yearly: { USD: 240, EUR: 240,}},
		  7: {Monthly: { USD: 20, EUR: 20,}, Yearly: { USD: 240, EUR: 240,}},
		},
		'ADDITIONAL-AGENT': { 
		  3: {Monthly: { USD: 10, EUR: 10,}, Yearly: { USD: 120, EUR: 120,}},
		  4: {Monthly: { USD: 15, EUR: 15,}, Yearly: { USD: 180, EUR: 180,}},
		  5: {Monthly: { USD: 20, EUR: 20,}, Yearly: { USD: 240, EUR: 240,}},
		  6: {Monthly: { USD: 30, EUR: 30,}, Yearly: { USD: 360, EUR: 360,}},
		  7: {Monthly: { USD: 40, EUR: 40,}, Yearly: { USD: 480, EUR: 480,}},
		},
	  };

	return _prizes?.[type]?.[plan.plan_type]?.[pay_mode_string]?.[currency] ?? null;
}

export const ChargeBeePortal =  ({ account_id, ...props }) => {
	const [ cbInstance, setCBinstance ] = useState(false);
	
	useEffect(() => {
		setTimeout(() => {
			const instance = window.Chargebee.getInstance();

			instance.setPortalSession(()=>{
				return $.post(`/accounts/create_portal_session`).then((response) => JSON.parse(response));
			})

			setCBinstance(instance);
		}, 200);
	}, []);


	const createPortal = () => {
		const portal = cbInstance.createChargebeePortal();

		portal.open({
			close:() => {
			}
		})
	}

	const type = props?.type ?? 'button';
	const Component = (type == 'link') ? ActionLink : ActionButton;
	return (
		<Component
			onClick={createPortal}
			autotranslate={props.autotranslate}
		>{props.children ?? "Buy"}</Component>
	);
};

export const UpgradeSubscription = (props) => {
	const cbInstance = useChargeBeeInstance();

	const getHostedPage = () => {
		cbInstance.openCheckout({
			hostedPage:() => {
				const data = {
					subscription_id:props.subscription_id,
				};

				if(props.itemPriceId != undefined) {
					data.itemPriceId = props.itemPriceId
				}
				return $.post(`/accounts/upgrade_subscription`, data).then((response) => JSON.parse(response));
			},
			success(hosted_page_id) {
				if(props.onSuccess != undefined) props.onSuccess();
			},
			close:() => {
			},
			step(step) {
			},
		});
	};

	const type = props?.type ?? 'button';
	const Component = (type == 'link') ? ActionLink : ActionButton;

	return (
		<Component
			onClick={getHostedPage}
			autotranslate={props.autotranslate}
		>{props.children ?? "Buy"}</Component>
	);
};

export const AddonSubscription = (props) => {
	const cbInstance = useChargeBeeInstance();

	const getHostedPage = () => {
		cbInstance.openCheckout({
			hostedPage:() => {
				const data = {
					subscription_id:props.subscription_id,
				};

				if(props.itemPriceId != undefined) {
					data.itemPriceId = props.itemPriceId;
				}
				if(props.quantity != undefined) {
					data.quantity = props.quantity;
				}
				return $.post(`/accounts/addon_subscription`, data).then((response) => JSON.parse(response));
			},
			success(hosted_page_id) {
				if(props.onSuccess != undefined) props.onSuccess();
			},
			error:(message)=>{
				if(props.onError != undefined) props.onError();
			},
			close:() => {
			},
			step(step) {
			},
		});
	};

	const type = props?.type ?? 'button';
	const Component = (type == 'link') ? ActionLink : ActionButton;

	return (
		<Component
			onClick={getHostedPage}
			autotranslate={props.autotranslate}
		>{props.children ?? "Buy"}</Component>
	);
};

const ChargeBee = ({ account_id, ...props }) => {
	const [ cbInstance, setCBinstance ] = useState(false);

	const [error,setError] = useState(false);
	
	useEffect(() => {
		setTimeout(() => {
			setCBinstance(window.Chargebee.getInstance())
		}, 200);
	}, []);

	const getHostedPage = () => {
		const key = props.type ?? 'plan_id';

		cbInstance.openCheckout({
			hostedPage:() => {
				const data = {
					account_id:account_id,
					[key]:props.item_id
				};

				if(props.quantity) data['quantity'] = props.quantity;
				return $.post(getRemotedbUrl(`/payments/chargebee`), data).then((response) => {
					const res = JSON.parse(response)
					if (res.status == 0) throw res.reason;
					return res;
				});
			},
			success(hosted_page_id) {
				if(props.onSuccess != undefined) props.onSuccess({hosted_page_id});
			},
			error(error){
				setError(error);
			},
			close:() => {
			},
			step(step) {

			},
		});
	};

	

	if (error) return (
		<FloatingLayer backButton={()=>setError(false)}>
			<div class="without_actions">
				<SectionTitle>Error</SectionTitle>

				<SectionSubtitle>Contact with our support team and provide this error message:</SectionSubtitle>

				<SectionSubtitle autotranslate={false}>{error}</SectionSubtitle>
			</div>
		</FloatingLayer>
	)

	const button_props = { other:(props?.classname ?? []).join(" ") };
	return (
		<ActionButton
			disabled={props.item_id == undefined || props.item_id == false}
			onClick={getHostedPage}
			autotranslate={props.autotranslate}
			_class={button_props}
		>{props.children ?? "Buy"}</ActionButton>
	);
};

export default (ChargeBee);